var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencilWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "People---Profile---General-Info",
    transform: "translate(-859.000000, -194.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Personal-Information",
    transform: "translate(112.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(735.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pencil-1",
    transform: "translate(12.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3385,11.677 C0.4135,11.752 0.5275,11.773 0.627,11.724 L3.294,10.3905 L1.625,8.721 L0.2915,11.3885 C0.2435,11.4845 0.2625,11.601 0.3385,11.677 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.076,2.7075 L11.6065,2.177 C12.094,1.6895 12.094,0.8965 11.6065,0.4095 C11.3705,0.174 11.0565,0.0435 10.7225,0.0435 C10.3885,0.0435 10.0745,0.174 9.8385,0.4095 L9.308,0.94 L11.076,2.7075 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "10.7225342 3.0610249 3.6974957 10.0860634 1.9297457 8.3183134 8.9547842 1.2932749"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWhite);
export default __webpack_public_path__ + "static/media/pencil-white.74083680e5becbc7ea136aae13eb5fd1.svg";
export { ForwardRef as ReactComponent };